const body = ()=> ({
  cart: {},
  disable_add_to_cart: false,
  disable_fan_club_product: false,
  show_discount: false,

  async getCart() {
    const url = `${window.Shopify.routes.root}cart.js`;
    const response = await fetch(url);

    if(response.status !== 200) return;

    const cart_data = await response.json();
    this.cart = cart_data;
  },

  disableFreeBook () {
    if(this.cart) {
     const gift_present = this.cart.items.find((item)=> item.properties['_FreeGift']);
      if(gift_present) {
        this.disable_add_to_cart = true;
        this.show_discount = true;
      } else {
        this.disable_add_to_cart = false;
        this.show_discount = false;
      }
    }
  },

  disableFanClub() {
    if(this.cart) {
      const gift_present = this.cart.items.filter((item)=> item.properties['_FreeFanClubBook']);
       if(gift_present.length > 1) {
         this.disable_fan_club_product = true;
       } else {
         this.disable_fan_club_product = false;
       }
     }
  },

  copyCode() {
    const code = this.$el.dataset.code;
    const label = this.$el.dataset.label;
    navigator.clipboard.writeText(code);
    this.$el.innerHTML = `Kopierter: <span>${code}</span>`

    setTimeout(()=> {
      this.$el.innerHTML = `<span>${label}</span>`;
    },1500)
  },

  moq() {
    const moq_elements = document.querySelectorAll('[data-moq]');
    moq_elements.forEach((el)=> {
      if(el.dataset.moq !== '') {
        const moq = Number(el.dataset.moq);
        const product_id = Number(el.dataset.id);
        const line_item = this.cart.items.filter((item)=> item.product_id === product_id);
        const label = document.getElementById(`product-${product_id}`);
    
        

        if (line_item.length > 0 && line_item[0].quantity >= moq) {
          el.disabled = true;
          if (label) {
            const max_quantity_label = label.querySelector('.max');
            const min_quantity_label = label.querySelector('.min');
            min_quantity_label.style.display = 'none';
            max_quantity_label.style.display = 'block';
          }
        } else {
          el.disabled = false;
          if (label) {
            const max_quantity_label = label.querySelector('.max');
            const min_quantity_label = label.querySelector('.min');
            min_quantity_label.style.display = 'block';
            max_quantity_label.style.display = 'none';
          }
        }
      }
    })
  },

  init() {
    this.getCart();

    this.$watch('cart', ()=> {
      this.disableFreeBook()
      this.disableFanClub()

      if (!this.disable_add_to_cart) {
        setTimeout(()=> {
          this.moq();
        }, 300)
      }
    })

    document.addEventListener("cart:change", () => {
      this.getCart()
    });
  }
})

document.addEventListener('alpine:init', () => {
  Alpine.data('body', body)
})